import { entryResources } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function EntryResources() {
  return (
    <section className="w-full bg-secondary-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            快速入口
          </h2>
          <p className="text-sm text-foreground-500">
            想直接跳到某一部分？从这里选一个入口。
          </p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {entryResources.map((entry, index) => (
            <Reveal key={entry.title} delay={index * 50}>
              <a
                href={entry.href}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-lg text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={entry.icon} />
                </span>
                <span className="flex-1">
                  <span className="block font-heading text-sm font-bold text-foreground-950">
                    {entry.title}
                  </span>
                  <span className="mt-0.5 block text-xs text-foreground-500">{entry.desc}</span>
                </span>
                <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}